// src/pages/HelpSupport.js
import React, { useState } from "react";
import LeftNav from "../common/LeftNav";
import TopNav from "../common/TopNav";
import { useNavigate } from "react-router-dom";
import personalleft from "../../assets/img/personal-left.svg";


import "../../assets/styles/HelpSupport.css";
export default function HelpSupport() {
  const navigate = useNavigate();
  const [showLegalTextarea, setShowLegalTextarea] = useState(false);
  const [legalText, setLegalText] = useState("");

  return (
    <div className="d-flex" style={{ background: "#fafbfc", minHeight: "100vh" }}>
      <LeftNav />
      <div className="main-content flex-grow-1">
        <TopNav />
        <div className="p-4">
          <div className="">
            <div className="card p-4 help-card">
              {/* Header */}
              <div className="d-flex align-items-center mb-4">
                <img
                  src={personalleft}
                  className="me-2"
                  width={28}
                  height={28}
                  alt="back"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(-1)}
                />
                <h6 className="mb-0 help-title">Help and Support</h6>
              </div>

              {/* List Items */}
              <div className="help-item d-flex justify-content-between align-items-center mb-3" onClick={()=>{
                navigate('/AdminFAQAccordion')
              }}>
                <span>FAQs</span>
                <span className="help-arrow">›</span>
              </div>

              <div className="help-item d-flex justify-content-between align-items-center mb-3" onClick={()=>{
                navigate('/Webadmincontact')
              }}>
                <span>Contact Support</span>
                <span className="help-arrow">›</span>
              </div>
               <div className="help-item d-flex justify-content-between align-items-center mb-3" onClick={()=>{
                navigate('/Policies')
              }}>
                <span>policies</span>
                <span className="help-arrow">›</span>
              </div>

              {/* <div className="help-item d-flex justify-content-between align-items-center" onClick={() => setShowLegalTextarea(!showLegalTextarea)}>
                <span>Legal, Terms & Conditions</span>
                <span className="help-arrow">›</span>
              </div> */}

              {/* Legal Terms Textarea */}
              {showLegalTextarea && (
                <div className="mt-3">
                  <label className="form-label" style={{ fontWeight: "500", marginBottom: "8px" }}>
                    Legal, Terms & Conditions
                  </label>
                  <textarea
                    className="form-control"
                    rows="8"
                    placeholder="Enter legal terms and conditions text here..."
                    value={legalText}
                    onChange={(e) => setLegalText(e.target.value)}
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      padding: "12px",
                      fontSize: "14px",
                      resize: "vertical"
                    }}
                  />
                  <div className="d-flex justify-content-end mt-3">
                    <button
                      className="btn btn-secondary me-2"
                      onClick={() => {
                        setShowLegalTextarea(false);
                        setLegalText("");
                      }}
                      style={{
                        padding: "8px 20px",
                        borderRadius: "8px"
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        console.log("Legal Text Saved:", legalText);
                        setShowLegalTextarea(false);
                      }}
                      style={{
                        padding: "8px 20px",
                        borderRadius: "8px"
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
